import { render, staticRenderFns } from "./storeMenuDialog.vue?vue&type=template&id=33d9d313&scoped=true"
import script from "./storeMenuDialog.vue?vue&type=script&lang=js"
export * from "./storeMenuDialog.vue?vue&type=script&lang=js"
import style0 from "./storeMenuDialog.vue?vue&type=style&index=0&id=33d9d313&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9d313",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d9d313')) {
      api.createRecord('33d9d313', component.options)
    } else {
      api.reload('33d9d313', component.options)
    }
    module.hot.accept("./storeMenuDialog.vue?vue&type=template&id=33d9d313&scoped=true", function () {
      api.rerender('33d9d313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/component/storeMenuDialog.vue"
export default component.exports